import { render, staticRenderFns } from "./RedPacket.vue?vue&type=template&id=28696886&"
import script from "./RedPacket.vue?vue&type=script&lang=js&"
export * from "./RedPacket.vue?vue&type=script&lang=js&"
import style0 from "./RedPacket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports